/** Normalizes badge labels so they're never full-caps: "HIGH" → "High", "CRITICAL" → "Critical". */
const titleCase = (s: string) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();

export default titleCase;
